import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetPrintBadgeRegistration, GetPrintBadgeRegistrationResponse } from '../api/dtos';
import useGet from './api/useGet';

const getData = (response?: SWRResponse<GetPrintBadgeRegistrationResponse, GetPrintBadgeRegistrationResponse>) => response?.data?.registrations;
const getError = (response?: SWRResponse<GetPrintBadgeRegistrationResponse, GetPrintBadgeRegistrationResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetPrintBadgeRegistrationResponse, GetPrintBadgeRegistrationResponse>) => ({
    registrations: response?.data?.registrations,
    count: response?.data?.count
});

export const useRegistrations = (
    page?: number,
    rows?: number,
    search?: string,
    sort?: string,
    descending?: boolean,
    configuration?: SWRConfiguration | undefined

) => {
    const request = useMemo(() => {
        return () => {
            return new GetPrintBadgeRegistration({
                page,
                rows,
                search,
                sort,
                descending
            });
        }
    }, [
        page,
        rows,
        search,
        sort,
        descending,
    ]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useRegistrations;